<template>
  <v-layout justify-start>
    <v-flex>
      <v-card class="mt-2">
        <v-container v-if="!systemOwnerLoading" fluid grid-list-md>
          <h3>ネットワーク名</h3>
          <v-text-field
            :disabled="loading"
            v-model="nameText"
            class="data-area"
          />
          <h3>ドメイン</h3>
          <v-text-field
            :value="systemOwner.theme.url.brandCustomDomain"
            disabled
            class="data-area"
          />
          <h3>サブドメイン</h3>
          <v-text-field
            :value="systemOwner.theme.url.brandSubDomain"
            disabled
            class="data-area"
          />
          <h3>テーマカラー</h3>
          <v-layout row wrap style="min-height: 120px;" class="data-area">
            <v-flex xs4 mt-4>
              <v-select
                v-model="themeNumber"
                :loading="!themeList.length"
                :disabled="loading"
                :items="themeList"
                item-text="name"
                item-value="id"
              />
            </v-flex>
            <v-spacer />
            <v-flex xs8>
              <img v-if="themeNumber" :src="previewImgSrc" class="preview" />
            </v-flex>
          </v-layout>
          <h3>Favicon・ロゴ</h3>
          <v-layout row wrap class="data-area">
            <v-flex xs2>
              <h4>Favicon</h4>
              <img :src="systemOwner.theme.favicon" />
            </v-flex>
            <v-flex xs10>
              <h4>ロゴ</h4>
              <img :src="systemOwner.theme.logo.large" />
            </v-flex>
            <v-flex xs12>
              Favicon・ロゴを変更する場合は担当営業までお問い合わせ下さい。
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-layout row wrap justify-end>
            <v-btn :loading="loading" @click="$emit('save')" color="primary">
              保存
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
    },
    systemOwnerLoading: {
      type: Boolean,
      default: true,
    },
    systemOwner: {
      type: Object,
    },
    themeList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nameText: {
      get() {
        if (!this.form) return ''
        return this.form.brandTitle
      },
      set(value) {
        this.$emit('setBrandTitle', value)
      },
    },
    themeNumber: {
      get() {
        if (!this.form) return ''
        return this.form.colorThemeId
      },
      set(value) {
        this.$emit('setColorThemeId', value)
      },
    },
    previewImgSrc() {
      if (!this.themeList.length || this.systemOwnerLoading) return ''
      return this.themeList.filter(theme => {
        return theme.id === this.themeNumber
      })[0].preview.image
    },
  },
}
</script>

<style scoped>
img .preview {
  height: 100px;
}
.data-area {
  padding-left: 5vw;
}
</style>
